export const MARKET_NEWS_DATA = "MARKET_NEWS_DATA";
export const MARKET_NEWS_START_LOADER = "MARKET_NEWS_START_LOADER";
export const MARKET_NEWS_STOP_LOADER = "MARKET_NEWS_STOP_LOADER";
export const MARKET_NEWS_HIDE_ERROR = "MARKET_NEWS_HIDE_ERROR";
export const MARKET_NEWS_SET_ERROR = "MARKET_NEWS_SET_ERROR";
